import styled from 'styled-components';
import { Avatar as MuiAvatar } from '@mui/material';
export var StyledAvatar = styled(MuiAvatar).withConfig({
  displayName: "style__StyledAvatar",
  componentId: "sc-lm159n-0"
})(["&&{background-color:", ";width:", ";height:", ";&:hover{cursor:pointer;}}"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  if (color === 'primary') {
    return theme.primary.main;
  }
  if (color === 'secondary') {
    return theme.secondary.main;
  }
  return color;
}, function (_ref2) {
  var width = _ref2.width;
  return width || '60px';
}, function (_ref3) {
  var width = _ref3.width;
  return width || '60px';
});